<template>
  <div id="root" class="toggle-menu">
    <menu-component whiteFont="true"></menu-component>
    <b-row class="full-height bg-img">
      <b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>¿En qué podemos ayudarte?</h1>
            <br />
            <span>Envíanos cualquier duda que tengas</span>
            <br/><br>
            <a class="link-to-section" href="#contact-form">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <div id="contact-form" class="alinov-info-container">
        <b-container class="info">
          <b-row class="title">
            <b-col>
              <h2>
                ¿Dónde localizarnos?
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" lg="6">
              <p>
                <b>Dirección:</b>
                <br/>
                <span>Santos Degollado 159, Ahualulco de Mercado, Jal.</span>
              </p>
              <p>
                <b>Correo Electrónico:</b>
                <br/>
                <span>erick.montanez@corporativoalinov.com.mx</span>
		 <br/>
		<span>ramses.lupercio@corporativoalinov.com.mx</span>
              </p>
              <p>
                <b>Redes Sociales:</b>
                <br/>
                <a target="_blank" href="https://www.facebook.com/corporativoalinov">
                  <i class="fab fa-facebook-square"></i>
                </a>
                <a target="_blank" href="https://www.instagram.com/corporativoalinov">
                  <i class="fab fa-instagram"></i>
                </a>
              </p>
            </b-col>
            <b-col sm="12" lg="6">
              <GmapMap
                :center="{lat:20.6953081, lng:-103.9532204}"
                :zoom="15"
                map-type-id="roadmap"
                :clickable="false"
                :draggable="true"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false
                }"
                style="width: 100%; height: 300px"
              >
                <GmapMarker
                  :position="{lat:20.6953081, lng:-103.9532204}"
                  :clickable="false"
                  :draggable="false"
                />
              </GmapMap>
            </b-col>
          </b-row>
          <b-row >
            <b-col>
              <h2>
                Envíanos un mensaje
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group
                  id="email_address_gr"
                  label="Correo Electrónico:"
                  label-for="email_address_input"
                >
                  <b-form-input
                    id="email_address_input"
                    type="email"
                    v-model="form.email"
                    required
                    placeholder="Escribe tu correo electrónico"
                  />
                </b-form-group>

                <b-form-group id="name_gr" label="Nombre:" label-for="name_input">
                  <b-form-input
                    id="name_input"
                    type="text"
                    v-model="form.name"
                    required
                    placeholder="Escribe tu nombre"
                  />
                </b-form-group>

								<b-form-group id="subject_gr" label="Asunto:" label-for="subject_input">
                  <b-form-input
                    id="subject_input"
                    type="text"
                    v-model="form.subject"
                    required
                    placeholder="Escribe un asunto"
                  />
                </b-form-group>

								<b-form-group label="Mensaje:" label-for="message_ts">
									<b-form-textarea
										id="message_ts"
										v-model="form.message"
										placeholder="Agrega un mensaje"
										required
										rows="3"
										max-rows="6"
									/>
								</b-form-group>

                <b-button class="alinov" type="submit" variant="success">Enviar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from "../shared/Footer.vue";
import $ from 'jquery'

export default {
  name: "Contact",
  components: {
    "menu-component": Menu,
    "footer-component": Footer
  },
  beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var headerHeight = 500;
      // $('.alinov-header').height() + 100;

      if (scroll >= headerHeight) {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-font");
      } else {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-font");
      }
    });
  },
	data() {
      return {
        userId: process.env.VUE_APP_EMAIL_USER_ID,
        form: {
          email: '',
					name: '',
					message: '',
					subject: ''
        },
        show: true
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        
        var data = {
            service_id: 'gmail',
            template_id: 'template_9F9SQSC9',
            user_id: this.userId,
            template_params: {
                'from_email': this.form.email,
                'reply_to': this.form.email,
                'from_name': this.form.name,
                'message': this.form.message,
                'subject': this.form.subject
            }
        };
        
        $.ajax('https://api.emailjs.com/api/v1.0/email/send', {
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json'
        }).done(function() {
            alert('¡Tu correo ha sido enviado!');
        }).fail(function() {
            alert('Ocurrió un error. Vuelte a intentarlo más tarde.');
        });
      },
      onReset(evt) {
        evt.preventDefault()
        this.form.email = ''
				this.form.name = ''
				this.form.message = ''
				this.form.subject = ''
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
			}
		}
};
</script>

<style lang="scss" scoped>
.full-height {
	background-image:linear-gradient( 
    rgba(0, 0, 0, 0.5), 
    rgba(0, 0, 0, 0.5) ), 
		url("../assets/images/contact-bg.jpg");
		background-position-y: 20%;
}

.alinov.btn {
	margin-top: 2rem;
}

i.fab {
  font-size: 5rem;
  margin-right: 0.5rem;
}
</style>
